import type { FC } from "react";

import { TerminalImportLogSearchForm } from "src/app/features/TerminalImportLog/components/forms/TerminalImportLogSearchForm";
import { TerminalImportLogsTable } from "src/app/features/TerminalImportLog/components/tables/TerminalImportLogsTable";
import type { TerminalImportLogEntity } from "src/app/features/TerminalImportLog/types/TerminalImportLogEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const TerminalImportLogsPage: FC<NoneOwnProps> = () => {
    const table = <TerminalImportLogsTable />;
    const searchForm = <TerminalImportLogSearchForm />;

    return (
        <PageLayout name="terminalImportLog_page">
            <PageTitle translationKey="menu.terminalImportLog" />
            <ResourceManager<TerminalImportLogEntity>
                useDataGroup
                dataMapperKey="terminalImportLogTableData"
                resource={ResourceName.TERMINAL_IMPORT_LOG}
                table={table}
                searchForm={searchForm}
                actions={[]}
            />
        </PageLayout>
    );
};
